import React from 'react';
import { Snackbar, Alert as MuiAlert, AlertProps, SnackbarProps } from '@mui/material';

interface NotificationProps {
  open: boolean;
  message: string;
  severity?: AlertProps['severity'];
  duration?: SnackbarProps['autoHideDuration'];
  onClose: () => void; 
}

const Message = ({
  open,
  message,
  severity = 'info',
  duration = 4000,
  onClose,
}: NotificationProps) => {
  
  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Posición estándar
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={severity}
        onClose={handleClose}
        sx={{ 
          width: '100%',
          fontWeight: 500,
          borderRadius: '8px'
        }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Message;